export type OptexDeliveryMethod = 'pickup' | 'sdd' | 'sth';

export type OptexDeliveryOption = {
    value: OptexDeliveryMethod;
    label: string;
};

export const OPTEX_DEFAULT_TITLE = 'Pickup & delivery';

export const OPTEX_DELIVERY_FILTER_ATTRIBUTE = 'optex-pickup-delivery';

export const OPTEX_DELIVERY_OPTIONS: OptexDeliveryOption[] = [
    { value: 'pickup', label: 'Pick up in store' },
    { value: 'sdd', label: 'Same-day delivery' },
    { value: 'sth', label: 'Ship to me' },
];

export const OPTEX_SHIP_TO_ME_ATTRIBUTE = 'shoppingOptions-isInStoreOnly';

export function getOptexButtonText(selectedMethod: OptexDeliveryMethod | null) {
    return OPTEX_DELIVERY_OPTIONS.find(option => option.value === selectedMethod)?.label ?? OPTEX_DEFAULT_TITLE;
}
